import { TireAlert, VehicleStatus } from './types';

export const STATUS_COLORS = {
  error: '#D50000',
  errorDark: '#ff6b6b',
  warning: '#F0B429',
  warningDark: '#ffd740',
  success: '#1da72b',
  successAlt: '#228B22',
  live: '#00EB7B',
  alertBar: '#E84040',
  primary: '#2196F3',
  muted: '#757575',
  faded: '#4c5cd1ad',
} as const;

export const vehicleStatusLabel: Record<VehicleStatus, string> = {
  LIGADO: 'Ligado',
  DESLIGADO: 'Desligado',
  DESATUALIZADO: 'Desatualizado',
};

export const vehicleStatusLabelMobile: Record<VehicleStatus, string> = {
  LIGADO: 'Ligado',
  DESLIGADO: 'Desligado',
  DESATUALIZADO: 'Desatual.',
};

export const vehicleStatusColor: Record<VehicleStatus, string> = {
  LIGADO: STATUS_COLORS.successAlt,
  DESLIGADO: STATUS_COLORS.muted,
  DESATUALIZADO: STATUS_COLORS.faded,
};

export const tireAlertLabel: Record<TireAlert, string> = {
  OK: 'OK',
  ALTA_TEMP: 'Alta Temp.',
  BAIXA_TEMP: 'Baixa Temp.',
  PRESSAO_BAIXA: 'Press. Baixa',
  PRESSAO_ALTA: 'Press. Alta',
  VAZIO: 'Vazio',
  SEM_SENSOR: '—',
};

export const tireAlertLabelMobile: Record<TireAlert, string> = {
  OK: 'OK',
  ALTA_TEMP: 'A.Temp',
  BAIXA_TEMP: 'B.Temp',
  PRESSAO_BAIXA: 'P.Baixa',
  PRESSAO_ALTA: 'P.Alta',
  VAZIO: 'Vazio',
  SEM_SENSOR: '—',
};

export const tireAlertColor: Record<TireAlert, string> = {
  OK: STATUS_COLORS.success,
  ALTA_TEMP: STATUS_COLORS.error,
  BAIXA_TEMP: STATUS_COLORS.error,
  VAZIO: STATUS_COLORS.error,
  PRESSAO_ALTA: STATUS_COLORS.warning,
  PRESSAO_BAIXA: STATUS_COLORS.warning,
  SEM_SENSOR: STATUS_COLORS.faded,
};

export const ROW_HEIGHT = 40;
export const OVERSCAN = 10;

export const thStyle = (isDark: boolean) => ({
  fontWeight: 700,
  fontSize: 11,
  textTransform: 'uppercase' as const,
  color: STATUS_COLORS.muted,
  whiteSpace: 'nowrap' as const,
  bgcolor: isDark ? '#031A1A' : '#fff',
});
